import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory, Redirect } from "react-router-dom";

import { useSnackbar } from "notistack";

import {
  makeStyles,
  Grid,
  Container,
  TextField,
  Paper,
  Typography,
  IconButton,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import InfoIcon from "@material-ui/icons/Info";
import CallMadeIcon from "@material-ui/icons/CallMade";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { getMyNft } from "../apiFunctions";
import LoadingButton from "../Components/LoadingButton";
import { getShareNFTDetail, tradeMyNFT } from "./NFTFunctions";

import useExploreLink from "../hooks/useExploreLink";

const useStyles = makeStyles((theme) => ({
  howItWorks: {
    color: "inherit",
    textDecoration: "none",
    "&:hover": {
      color: `${theme.palette.primary.main} !important`,
    },
  },

  mainPaperContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    padding: theme.spacing(2),
    display: "flex",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexFlow: "column",
    },
  },

  infoPaperContainer: {
    borderRadius: theme.spacing(2),

    padding: theme.spacing(2),
  },

  imageBox: {
    width: "400px",
    height: "400px",
    order: "1",
    marginLeft: theme.spacing(2),

    [theme.breakpoints.down("md")]: {
      width: "350px",
      height: "350px",
    },

    [theme.breakpoints.down("sm")]: {
      order: "0",
      height: "300px",
      width: "100%",
      marginLeft: "0",
      marginBottom: theme.spacing(2),
    },
  },

  skeletonImage: {
    borderRadius: theme.spacing(2),
  },

  nftImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: theme.spacing(2),
  },

  infoBox: {
    flex: "1",
    order: "0",
    [theme.breakpoints.down("sm")]: {
      order: "1",
    },
  },

  hr: {
    color: theme.palette.grey[400],
    marginLeft: `-${theme.spacing(2)}px`,
    marginRight: `-${theme.spacing(2)}px`,
  },

  moreInfo: {
    color: "inherit",
    textDecoration: "none",
    "&:hover": {
      color: `${theme.palette.primary.main} !important`,
    },
  },

  maticMustPaid: {
    color: theme.palette.error.main,
  },

  buttonIconBox: {
    background: theme.palette.background.default,
    width: "32px",
    height: "32px",
    borderRadius: "12px",
    cursor: "pointer",
  },
  buttonIconSVG: {
    fontSize: "14px",
  },

  exploreIcon: {
    fontSize: "inherit",
    marginLeft: theme.spacing(1),
  },
}));

function MyNFTDetail({ network }) {
  const history = useHistory();
  let { contract, id } = useParams();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [convertExploreLink] = useExploreLink();

  const [myNFT, setMyNFT] = useState({});
  const [fieldValue, setFieldValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [mainLoading, setMainLoading] = useState(true);
  const [shareDetail, setShareDetail] = useState({
    feeTokenAmount: 0,
    initLiquidityTokenAmount: 0,
    minLiquidityEthAmount: 0,
  });

  const calcMaticEachShare = () => {
    const parsedInput = parseFloat(fieldValue);
    if (parsedInput && !isNaN(parsedInput)) {
      return parsedInput / 1000000;
    }
    return 0;
  };

  const requiredMaticPaid = () => {
    const parsedInput = parseFloat(fieldValue);
    if (parsedInput && !isNaN(parsedInput)) {
      return parsedInput / 10;
    }
    return 0;
  };

  const calcReceiveShare = () => {
    const { feeTokenAmount, initLiquidityTokenAmount } = shareDetail;
    if (feeTokenAmount && initLiquidityTokenAmount) {
      return 1000000 - feeTokenAmount - initLiquidityTokenAmount;
    }
    return 0;
  };

  const get_nft = async () => {
    // start loading
    setMainLoading(true);

    const share_detail = await getShareNFTDetail(
      network.nftSharing,
      network.signer
    );

    const newDetail = { ...shareDetail };
    newDetail.feeTokenAmount = share_detail.feeTokenAmount;
    newDetail.initLiquidityTokenAmount = share_detail.initLiquidityTokenAmount;
    newDetail.minLiquidityEthAmount = share_detail.minLiquidityEthAmount;

    setShareDetail(newDetail);
    console.log(newDetail);

    let content = {
      id,
      contract,
      chainID: network.chainID,
    };
    await getMyNft(content).then((res) => {
      if (res) {
        setMyNFT(res);
        console.log(res);
      }
    });

    // stop loading
    setMainLoading(false);
  };

  // Determines whether the button should be enabled or not
  const isButtonEnabled = () => {
    // If both coins have been selected, and a valid float has been entered for both, which are less than the user's balances, then return true
    return (
      requiredMaticPaid() &&
      shareDetail.minLiquidityEthAmount < requiredMaticPaid()
    );
  };

  const tradeNFT = async () => {
    console.log("Attempting to Trade nft...");
    setLoading(true);

    await tradeMyNFT(
      network.wethAddress,
      `${+fieldValue}`,
      myNFT.token_address,
      myNFT.token_id,
      network.nftSharing,
      network.signer,
      (res) => {
        if (res.status) {
          setLoading(false);

          // If the transaction was successful, we clear to input to make sure the user doesn't accidental redo the transfer
          setFieldValue("");
          enqueueSnackbar("Trade NFT Successful", {
            variant: "success",
            autoHideDuration: 5000,
          });
        } else {
          setLoading(false);
          enqueueSnackbar("Trade NFT Failed (" + res.e.reason + ")", {
            variant: "error",
            autoHideDuration: 5000,
          });
        }
      }
    ).catch((e) => {
      setLoading(false);
      enqueueSnackbar("Trade NFT Failed (" + e.reason + ")", {
        variant: "error",
        autoHideDuration: 5000,
      });
    });
  };

  useEffect(() => {
    const myNFTTimeout = setTimeout(() => {
      if (network.stacking) {
        get_nft();
      }
    }, 1000);
    return () => clearTimeout(myNFTTimeout);
  }, []);

  return (
    <>
      {network.chainID != 56 ? (
        <div id="my-nft-detail">
          <Container maxWidth="xl">
            <Paper elevation={0} className={classes.mainPaperContainer}>
              <div className={classes.infoBox}>
                <IconButton
                  onClick={() => history.push("/my-nfts")}
                  variant="contained"
                  className={classes.buttonIconBox}
                >
                  <ArrowBackIcon className={classes.buttonIconSVG} />
                </IconButton>
                <Typography variant="h4" className="fw-bold mb-2">
                  {mainLoading ? (
                    <Skeleton width={100} />
                  ) : (
                    <>{myNFT?.metadata?.name || myNFT.name}</>
                  )}
                </Typography>
                <Typography variant="body1" className="mb-3 mb-md-5">
                  {mainLoading ? (
                    <Skeleton width={50} />
                  ) : (
                    <>#{myNFT.token_id}</>
                  )}
                </Typography>

                {mainLoading && (
                  <Typography variant="body1" className="mb-3 mb-md-5">
                    <Skeleton />
                    <Skeleton />
                  </Typography>
                )}
                {myNFT?.metadata?.description && (
                  <Typography variant="body1" className="mb-3 mb-md-5">
                    {myNFT?.metadata?.description}
                  </Typography>
                )}

                <Typography variant="body1">
                  {mainLoading ? (
                    <Skeleton width={100} />
                  ) : (
                    <>
                      <a
                        href={convertExploreLink(
                          network.chainID,
                          myNFT.token_address
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.moreInfo}
                      >
                        Explorer
                        <CallMadeIcon className={classes.exploreIcon} />
                      </a>
                    </>
                  )}
                </Typography>
              </div>

              <div className={classes.imageBox}>
                {mainLoading || !myNFT?.metadata?.image ? (
                  <Skeleton
                    variant="rect"
                    height="100%"
                    className={classes.skeletonImage}
                  />
                ) : (
                  <img
                    src={myNFT?.metadata?.image}
                    alt={myNFT?.metadata?.name || "nft"}
                    className={classes.nftImage}
                  />
                )}
              </div>
            </Paper>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Paper elevation={0} className={classes.infoPaperContainer}>
                  <Typography
                    variant="body1"
                    className="fw-bold d-flex align-items-center gap-2"
                  >
                    <InfoIcon />
                    Note
                  </Typography>
                  <hr className={classes.hr} />
                  <Typography variant="body2">
                    Everyone who pays NFT market price can withdraw NFT and all
                    NFT-Token holders can redeem their NFT-Tokens by market
                    price
                  </Typography>

                  <Typography variant="body2" className="mt-4">
                    <Link to="/nft-pools" className={classes.moreInfo}>
                      Need more information ?
                    </Link>
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} md={8}>
                <Paper elevation={0} className={classes.infoPaperContainer}>
                  <Typography variant="body1" className="fw-bold">
                    Trade NFT
                  </Typography>
                  <hr className={classes.hr} />

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="price" className="mb-1">
                        NFT Start Price (Matic)
                      </label>
                      <TextField
                        id="price"
                        value={fieldValue}
                        onChange={(e) => setFieldValue(e.target.value)}
                        variant="outlined"
                        placeholder="Start Price (Matic)"
                        fullWidth
                        disabled={!myNFT.token_id}
                      />
                      <div className="d-flex flex-column">
                        {!!requiredMaticPaid() && (
                          <Typography
                            variant="caption"
                            className={classes.maticMustPaid}
                          >
                            {Number(requiredMaticPaid()).toLocaleString()} Matic
                            must be paid
                          </Typography>
                        )}
                        {!!requiredMaticPaid() &&
                          requiredMaticPaid() <
                            shareDetail.minLiquidityEthAmount && (
                            <Typography
                              variant="caption"
                              className={classes.maticMustPaid}
                            >
                              Minimum must paid is{" "}
                              {shareDetail.minLiquidityEthAmount} Matic
                            </Typography>
                          )}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" className="mb-3">
                        1.000.000 Shares will be generated
                      </Typography>
                      <Typography variant="body2" className="mb-3">
                        {calcMaticEachShare()} Matic for each share
                      </Typography>
                      <Typography variant="body2" className="mb-3">
                        System fee (5%):{" "}
                        {Number(shareDetail.feeTokenAmount).toLocaleString()}{" "}
                        Share
                      </Typography>
                      <Typography variant="body2" className="mb-3">
                        Required Liquidity (10%):{" "}
                        {Number(
                          shareDetail.initLiquidityTokenAmount
                        ).toLocaleString()}{" "}
                        Shares + {Number(requiredMaticPaid()).toLocaleString()}{" "}
                        Matic
                      </Typography>

                      <Typography variant="body2" className="mb-3">
                        You need to pay{" "}
                        {Number(requiredMaticPaid()).toLocaleString()} Matic to
                        create first liquidity.
                        <br />
                        This will allow users to swap NFTT/WETH pair.
                        <br />
                        You can remove this liquidity any time you want
                      </Typography>

                      <Typography variant="body2" className="mb-3">
                        You will receive
                        <br />
                        {Number(calcReceiveShare()).toLocaleString()} shares +
                        liquidity (
                        {Number(shareDetail.feeTokenAmount).toLocaleString()}{" "}
                        Share / {Number(requiredMaticPaid()).toLocaleString()}{" "}
                        Matic)
                      </Typography>
                    </Grid>
                  </Grid>

                  <div className="mt-4 d-flex justify-content-center">
                    <LoadingButton
                      loading={loading}
                      valid={isButtonEnabled()}
                      success={false}
                      fail={false}
                      onClick={tradeNFT}
                    >
                      {loading ? "processing" : "Start trade nft"}
                    </LoadingButton>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </div>
      ) : (
        <Redirect to="/invest" />
      )}
    </>
  );
}

export default MyNFTDetail;
